﻿window.showToast = function (message, type = 'success') {
  const $toast = $('#globalToast');
  const $body = $('#globalToastBody');

  $toast.removeClass('toast-danger bg-warning');
  if (type === 'error') {
    $toast.addClass('toast-danger');
  } else if (type === 'warning') {
    $toast.addClass('bg-warning');
  }

  $body.text(message);
  bootstrap.Toast.getOrCreateInstance($toast[0]).show();
};
